import Vue, { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';

Vue.directive('bg-img', {
  bind: onBindOrUpdate,
  update: onBindOrUpdate,
});

function onBindOrUpdate(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
  if (binding.value == binding.oldValue) {
    return;
  }

  el.style.backgroundImage = `url(${binding.value})`;
}
